import { render, staticRenderFns } from "./ListBnRetrClients.vue?vue&type=template&id=01f6a773&scoped=true&"
import script from "./ListBnRetrClients.vue?vue&type=script&lang=js&"
export * from "./ListBnRetrClients.vue?vue&type=script&lang=js&"
import style0 from "./ListBnRetrClients.vue?vue&type=style&index=0&id=01f6a773&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f6a773",
  null
  
)

export default component.exports